import { withStyles } from '@mui/styles';
import { Tooltip } from '@mui/material';
import { Backgrounds, Colors } from 'utils';

export const SimpleTooltip = withStyles((theme) => ({
    tooltip: {
        fontFamily: 'Open Sans, sans-serif',
        background: Colors.TextSecondary,
        padding: '6px 16px',
        borderRadius: '6px',
        fontSize: '14px',
        fontWeight: 400,
        color: Colors.TextWhite,
        borderColor: Backgrounds.Base,
        lineHeight: 'normal',

        // padding: "8px",
        // background: Backgrounds.Base,
        // maxWidth: 396,
        // background: Colors.TextSecondary,
        // height: 'auto',
        // display: 'flex',
        // alignItems: 'center',
        // borderRadius: '6px',
        // fontSize: '14px',
        // padding: '6px 16px',
        // lineHeight: 'normal',
    },
}))(Tooltip);
